import React from "react";

function normalizeFlag(value) {
  if (value === 1 || value === true || value === "1") return 1;
  if (value === 0 || value === false || value === "0") return 0;
  return null;
}

export function getSlaveOtaLedColor(
  slaveOtaDownloadComplete,
  slaveOtaFatRepaired,
  slaveOtaHashMatched,
) {
  const downloadComplete = normalizeFlag(slaveOtaDownloadComplete);
  const fatRepaired = normalizeFlag(slaveOtaFatRepaired);
  const hashMatched = normalizeFlag(slaveOtaHashMatched);

  if (
    downloadComplete === 0 &&
    fatRepaired === 0 &&
    hashMatched === 0
  ) {
    return null;
  }

  if (downloadComplete === 0 || hashMatched === 0) return "red";

  if (downloadComplete === 1 && hashMatched === 1 && fatRepaired === 1) {
    return "orange";
  }

  if (downloadComplete === 1 && hashMatched === 1 && fatRepaired === 0) {
    return "green";
  }

  return null;
}

function SlaveOtaStatusLed(props) {
  const ledColor = getSlaveOtaLedColor(
    props.slaveOtaDownloadComplete,
    props.slaveOtaFatRepaired,
    props.slaveOtaHashMatched,
  );

  if (!ledColor) return null;

  const colorMap = {
    green: "#00c853",
    orange: "#ff9800",
    red: "#ff1744",
  };
  const color = colorMap[ledColor];

  return (
    <span
      aria-label={`Slave OTA status ${ledColor}`}
      title={`Slave OTA status: ${ledColor}`}
      style={{
        backgroundColor: color,
        border: "1px solid rgba(255, 255, 255, 0.9)",
        borderRadius: "50%",
        boxShadow: `0 0 5px ${color}`,
        display: "inline-block",
        height: "10px",
        position: "absolute",
        right: "9px",
        top: "50%",
        transform: "translateY(-50%)",
        width: "10px",
      }}
    />
  );
}

export default SlaveOtaStatusLed;
